"use client"

// One observer for every revealing element on the page. A feed runs to thirty-odd
// sections, and an observer each is thirty sets of registration callbacks doing
// identical work.
let shared: IntersectionObserver | null = null

const SCROLLED_PAST_REACH_PX = 100000

export const revealObserver = () => {
  if (typeof IntersectionObserver === "undefined") return null
  shared ??= new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.setAttribute("data-in", "")
        shared?.unobserve(entry.target)
      }
    },
    // Arrive a little before the edge, so the movement finishes as the section
    // settles rather than starting once it is already read.
    { rootMargin: `${SCROLLED_PAST_REACH_PX}px 0px -8% 0px`, threshold: 0.01 }
  )
  return shared
}
